export default userAgent;

function userAgent() {
  return import('ua-parser-js' /* webpackChunkName: "ua_parser" */)
    .then(({ default: uaParser }) => {
      return new uaParser().getResult();
    });
}